import { render, staticRenderFns } from "./service-guide-card.vue?vue&type=template&id=780e238c&scoped=true"
import script from "./service-guide-card.vue?vue&type=script&lang=js"
export * from "./service-guide-card.vue?vue&type=script&lang=js"
import style0 from "./service-guide-card.vue?vue&type=style&index=0&id=780e238c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780e238c",
  null
  
)

export default component.exports